import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import HomePage from "./pages/HomePage";
import TestimonialsPage from "./pages/TestimonialsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import TestimonialReviewPage from "./pages/TestimonialReviewPage";
import SpicesGuidePage from "./pages/SpicesGuidePage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/testimonials/review" element={<TestimonialReviewPage />} />
            <Route path="/products/:productId" element={<ProductDetailPage />} />
            <Route path="/spices-guide" element={<SpicesGuidePage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
